/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindingDto } from './FindingDto';
import {
    FindingDtoFromJSON,
    FindingDtoFromJSONTyped,
    FindingDtoToJSON,
    FindingDtoToJSONTyped,
} from './FindingDto';

/**
 * 
 * @export
 * @interface ResultResponse
 */
export interface ResultResponse {
    /**
     * 
     * @type {string}
     * @memberof ResultResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultResponse
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultResponse
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultResponse
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof ResultResponse
     */
    start?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ResultResponse
     */
    end?: Date;
    /**
     * 
     * @type {string}
     * @memberof ResultResponse
     */
    remarks?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultResponse
     */
    currentMaturity?: number;
    /**
     * 
     * @type {number}
     * @memberof ResultResponse
     */
    targetMaturity?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultResponse
     */
    statement?: string;
    /**
     * 
     * @type {FindingDto}
     * @memberof ResultResponse
     */
    finding?: FindingDto;
}

/**
 * Check if a given object implements the ResultResponse interface.
 */
export function instanceOfResultResponse(value: object): value is ResultResponse {
    return true;
}

export function ResultResponseFromJSON(json: any): ResultResponse {
    return ResultResponseFromJSONTyped(json, false);
}

export function ResultResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'start': json['start'] == null ? undefined : (new Date(json['start'])),
        'end': json['end'] == null ? undefined : (new Date(json['end'])),
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
        'currentMaturity': json['currentMaturity'] == null ? undefined : json['currentMaturity'],
        'targetMaturity': json['targetMaturity'] == null ? undefined : json['targetMaturity'],
        'statement': json['statement'] == null ? undefined : json['statement'],
        'finding': json['finding'] == null ? undefined : FindingDtoFromJSON(json['finding']),
    };
}

export function ResultResponseToJSON(json: any): ResultResponse {
    return ResultResponseToJSONTyped(json, false);
}

export function ResultResponseToJSONTyped(value?: ResultResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'uuid': value['uuid'],
        'title': value['title'],
        'description': value['description'],
        'start': value['start'] == null ? undefined : ((value['start']).toISOString()),
        'end': value['end'] == null ? undefined : ((value['end']).toISOString()),
        'remarks': value['remarks'],
        'currentMaturity': value['currentMaturity'],
        'targetMaturity': value['targetMaturity'],
        'statement': value['statement'],
        'finding': FindingDtoToJSON(value['finding']),
    };
}

